// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox-column[data-v-71146dc5]{width:50px}.card-divider[data-v-71146dc5]{border-bottom:1px solid #dee2e6}", ""]);
// Exports
module.exports = exports;
